import { useEffect, useState } from 'react';

import { SelectOption } from '@/shared/types';

import { getCountrySelect } from '@/api/apiService';

interface Props {
  id: string;
}

export const CountryDatalist: React.FC<Props> = ({ id }) => {
  const [options, setOptions] = useState<SelectOption[]>([]);

  useEffect(() => {
    if (options.length) return;
    getCountrySelect(setOptions);
  }, [options.length]);

  return (
    <datalist id={id}>
      {options.map((country) => (
        <option key={country.id} value={country.label ?? ''} />
      ))}
    </datalist>
  );
};
